import { useCallback, useEffect, useState } from 'react';

interface UseElementSizeProps {
  enabled?: boolean;
}

export const useElementSize = <T extends HTMLElement = HTMLDivElement>(
  { enabled }: UseElementSizeProps = { enabled: true }
) => {
  const [element, setElement] = useState<T | null>(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const ref = useCallback((node: T | null) => setElement(node), []);

  useEffect(() => {
    if (!element || !enabled) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width: nextWidth, height: nextHeight } = entry.contentRect;
      setWidth(nextWidth);
      setHeight(nextHeight);
    });

    observer.observe(element);

    const { width: initialWidth, height: initialHeight } =
      element.getBoundingClientRect();
    setWidth(initialWidth);
    setHeight(initialHeight);

    return () => {
      observer.disconnect();
    };
  }, [element, enabled]);

  return { ref, width, height };
};
